export var fa = function (n) {
    if (process.env.NODE_ENV === 'test') {
        return n;
    }
    return Number(n).toLocaleString('fa', {
        useGrouping: false
    });
};
export var weekDayNames = {
    jalali: {
        normal: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
        short: ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج']
    },
    gregorian: {
        normal: ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        short: ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    }
};
//# sourceMappingURL=week-day.js.map